import { render, staticRenderFns } from "./PortalRelatorio.vue?vue&type=template&id=1e1ec540&"
import script from "./PortalRelatorio.vue?vue&type=script&lang=js&"
export * from "./PortalRelatorio.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports